import Domain from 'helpers/Domain';
import SignUpComponent from 'aa/vue/components/SignUp';
import Step from 'models/steps/Step';
import { SKIP_EXPLAINER_STEPS, SWITCH_PLAN_ENABLED } from 'aa/helpers/featureConstants';

export default class SignUp extends Step {
    path = '/account/signup/createaccount';
    name = 'SIGNUP';
    component = SignUpComponent;
    requireAuth = false;
    requireNonAuth = true;
    allowGhost = Domain.isDomestic();
    countStep = true;
    props = true;

    checkFlowRedirect(from, to) {
        return Domain.isDomestic()
            ? this.usCheckFlowRedirect(from, to)
            : this.intlCheckFlowRedirect(from, to);
    }

    usCheckFlowRedirect(from, to) {
        const { name } = from;
        // START TEST CBSCOMSUB-8800: Purchase Funnel Ordering
        if (this._store.getters['variant/purchaseFunnelOrdering']) {
            return null;
        }
        // END TEST CBSCOMSUB-8800: Purchase Funnel Ordering

        const redirectUrl = to?.query?.redirectUrl || from?.query?.redirectUrl;

        if (redirectUrl && redirectUrl.includes('/account/direct/')) {
            return null;
        }

        // Partner billing flow (e.g. /partner-auth/optimum): billing is handled by the
        // partner, so skip the plan-picker redirect — mirrors intlCheckFlowRedirect
        if (to?.params?.fromPartnerConfirmation === true) {
            return null;
        }

        if (
            this._store.getters.featureIsActive(SWITCH_PLAN_ENABLED) &&
            !this._store.getters['flow/skipPlan'] &&
            name !== 'MVPD'
        ) {
            if (!this._store.getters['plan/selectedPlan']) {
                if (this._store.getters.featureIsActive(SKIP_EXPLAINER_STEPS)) {
                    return { name: 'PLAN' };
                } else {
                    return { name: 'plan_explainer' };
                }
            }
        }
        return null;
    }

    intlCheckFlowRedirect(from, to) {
        // START A/B TEST PLOCTOPLUS-1391 : Skip Explainer Steps
        if (this._store.getters['variant/isIntlRemoveExplainerSteps']) {
            return null;
        }
        // END A/B TEST PLOCTOPLUS-1391 : Skip Explainer Steps
        const { name } = from;
        const { params, query } = to;
        const isSkipExp = this._store.getters.featureIsActive(SKIP_EXPLAINER_STEPS);
        const isDirectFlow = query?.redirectUrl && query?.redirectUrl.includes('/account/direct/');

        return isDirectFlow ||
            name === 'sign_up_explainer' ||
            name === 'MVPD' ||
            this._store.getters['flow/isGift'] ||
            params.fromPartnerConfirmation === true || // TODO: PPLUSINTL-12284: Change this value when component is refactored
            isSkipExp
            ? null
            : { name: 'sign_up_explainer' };
    }

    /**
     * @param to
     * @returns {{path: *, name: *}}
     */
    getTrackingArgs(to) {
        const args = super.getTrackingArgs(to);
        args.pageTitle = 'Paramount+ Sign Up - CBS.com';
        args.pageName = this.path;

        if (to?.query && to.query?.redirectUrl?.includes('account/direct')) {
            const queryParamsString = to.query.redirectUrl.split('?')[1];
            const searchParams = new URLSearchParams(queryParamsString);
            const tier = searchParams.get('tier');
            const cadence = searchParams.get('cadence');
            const isTierNumeric = !isNaN(parseInt(tier));

            if (tier && cadence && isTierNumeric) {
                this._store.dispatch('plan/updateSelectedPlanWithTypeandTier', {
                    planType: cadence,
                    tier: parseInt(tier),
                    trial: true,
                });
            }
        }

        const productParams = this._store.getters['getProductParamsForTracking'];
        const signUpParams = this._store.getters['getTrackingParamsForSignUp'];

        Object.assign(args, productParams, signUpParams);

        return args;
    }
}
